import React from "react";

class SimpleOrderProduct extends React.Component {

    constructor(props){

        super(props)
    }


    render(){

        let product = this.props.product;

        return (
            <div className="product-wrapper">
                <div className="card bg-danger mt-2">
                    <div className="card-body">
                        <div className="row">
                            <div className="col">{product.name} {product.model} {product.brand} {product.color} {product.size}</div>
                            <div className="col">{product.quantity}</div>
                            <div className="col"></div>
                            <div className="col"></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


}

export default SimpleOrderProduct;